import { sendPatientAction } from './patientWritesClient';

/** Which of the patient's two designations a write is setting. */
export type PrimaryDatasetKind = 'image' | 'structureSet';

const ENDPOINT: Record<PrimaryDatasetKind, string> = {
    image: 'primary-image',
    structureSet: 'primary-structure-set',
};

/**
 * Hand-written client for the connector-next primary-designation endpoints
 * (the generated client is not used for mutations that need If-Match).
 *
 * A null `datasetId` clears the designation. Cleared means "not chosen", not
 * "use the heuristic": the open then falls back to its own defaults, which is
 * a different statement and one the user can make deliberately. The write is
 * not part of a dataset save, so it carries no save attempt id. Resolves to
 * the patient's next version.
 */
export function postPrimaryDataset(
    patientId: string,
    kind: PrimaryDatasetKind,
    datasetId: string | null,
    ifMatch: string
): Promise<string> {
    return sendPatientAction('POST', patientId, ENDPOINT[kind], ifMatch, {
        datasetId,
    });
}

/**
 * The same designation on one of the patient's cases. Guarded by the
 * patient's version: a case is part of the patient.
 */
export function postCasePrimaryDataset(
    patientId: string,
    caseId: string,
    kind: PrimaryDatasetKind,
    datasetId: string | null,
    ifMatch: string
): Promise<string> {
    return sendPatientAction(
        'POST',
        patientId,
        `cases/${caseId}/${ENDPOINT[kind]}`,
        ifMatch,
        { datasetId }
    );
}
